<script lang="ts">
    import FreeformScene from "./FreeformScene.svelte";
    import GuidedScene from "./GuidedScene.svelte";
    import { SceneKinds } from "./Soundboard";
    import { soundBoard } from "./store";
    import Tutorial from "./tutorial/Tutorial.svelte";

    export let duplicateCallback: (evt, scene, idx) => void;
</script>

{#if $soundBoard["scenes"].length == 0}
    <Tutorial />
{/if}
{#each $soundBoard["scenes"] as scene, idx (scene.id)}
    {#if scene.kind === SceneKinds.Freeform}
        <FreeformScene
            {scene}
            sceneId={scene.id}
            duplicateCallback={(evt) => duplicateCallback(evt, scene, idx)}
        />
    {:else if scene.kind === SceneKinds.Guided}
        <GuidedScene
            {scene}
            duplicateCallback={(evt) => duplicateCallback(evt, scene, idx)}
        />
    {/if}
{/each}
